import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from 'lodash-es';

const MODULE_PREFIX = "[ KYC ]";

const Actions = {
  setIsFoDisclosureRequired: `${MODULE_PREFIX} setIsFoDisclosureRequired`,
  updateFoDisclosureRequired: `${MODULE_PREFIX} updateFoDisclosureRequired`,
};

export const setIsFoDisclosureRequired = createAction(
  Actions.setIsFoDisclosureRequired
);

export const updateFoDisclosureRequired = createAction(
  Actions.updateFoDisclosureRequired
);

export const getIsFoDisclosureRequired = (state) => {
  const isFoDisclosureRequired = get(state, "foDisclosure.isFoDisclosureRequired", false);
  return isFoDisclosureRequired;
}

const initialState = {
  isFoDisclosureRequired: false,
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setIsFoDisclosureRequired, (state, action) => {
    state.isFoDisclosureRequired = action.payload;
  });
});
